
let zoom_elements = document.querySelectorAll('.zoom')

zoom_elements.forEach(zoom => {

    zoom.addEventListener('mousemove', (e) => {
    
        zoom.style.backgroundImage = `url(${zoom.dataset.zoom})`
    
        let zoomer = e.currentTarget;
        let offsetX, offsetY, x, y;
    
        e.offsetX ? (offsetX = e.offsetX) : (offsetX = e.touches[0].pageX);
        e.offsetY ? (offsetY = e.offsetY) : (offsetX = e.touches[0].pageX);
        x = (offsetX / zoomer.offsetWidth) * 100;
        y = (offsetY / zoomer.offsetHeight) * 100;
        zoomer.style.backgroundPosition = x + "% " + y + "%";
    }) 
})


zoom_elements.forEach(zoom => {
    zoom.addEventListener('mouseleave', () => {
        zoom.style.backgroundImage = 'none'
    }) 
})